module.exports = (__webpack_require__(9))(892);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/card/index.js from dll-reference antd_library
// module id = 1035
// module chunks = 42